import { render } from "./ChatNavigation.vue?vue&type=template&id=5116d2b9"
import script from "./ChatNavigation.vue?vue&type=script&lang=js"
export * from "./ChatNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Data/2022/cimt2022/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__